<template>
	<BasicLayout>
		<el-row>
			<el-col :xs='{span: 24, offset: 0}' :sm='{span: 22, offset: 1}' :md='{span: 20, offset: 2}' :lg='{span: 18, offset: 3}'>
				<stats />
			</el-col>
		</el-row>
	</BasicLayout>
</template>

<script>
import BasicLayout from '@/layouts/basic.layout.vue'
import Stats from '@/components/stats.component.vue'

export default {
	name: 'stats-page',
	components: { BasicLayout, Stats }
}
</script>
